import { throttle } from '../utils';

function directive(sellerService, $q, dealerChatService, pageStateService, leadFormService) {
    return {
        bindings: {
            listingDetailDto: '@'
        },
        link,
        restrict: 'EA',
        controllerAs: '$ctrl'
    };

    function link(scope, element, attrs) {

        const stickyNav = document.querySelector('.sticky-navigation');
        const scrollHandler = throttle(toggleStickyNav, 33);
        const scrollOffset = document.querySelector('.details').offsetTop;

        scope.showChat = false;
        document.addEventListener('scroll', scrollHandler, {passive:true});

        function init(){

            toggleStickyNav();
            setupChat();
        }

        function toggleStickyNav() {
            const pageYOffset = window.pageYOffset;

            const footer = document.querySelector('footer');
            const footerThreshold = footer.offsetTop + footer.offsetHeight;
            const scrollAmount = window.scrollY + window.innerHeight;

            if ( scrollAmount >= footerThreshold ) {
                stickyNav.classList.remove('sticky-navigation--fixed');
                stickyNav.classList.add('sticky-navigation--relative');
            } else if (pageYOffset > scrollOffset) {
                stickyNav.classList.add('sticky-navigation--fixed');
                stickyNav.classList.remove('sticky-navigation--relative');
            } else if (pageYOffset <= scrollOffset) {
                stickyNav.classList.remove('sticky-navigation--fixed');
                stickyNav.classList.remove('sticky-navigation--relative');
            }
        }

        init();

        function setupChat(){
            $q.all([sellerService.getSeller()])
            .then(processListingData).catch((e) => {
                scope.showPhone = false;
                scope.toggleShowPhone = toggleShowPhone;
            });
        }

        function toggleShowPhone() {
            scope.showPhone = !scope.showPhone;
        }

        function processListingData(responses) {
            let hasTextAvailable;
            const NEW_STOCK_TYPE_CODE = 61;
            const USED_STOCK_TYPE_CODE = 62;
            const PAGEID = 2104;

            attrs.listingData = JSON.parse(attrs.listingData);
            attrs.customerId = attrs.listingData.customerId;
            attrs.isActiveEngage = attrs.listingData.parentOrgName === "AutoNation";
            attrs.isDealerInspire = attrs.listingData.isDealerInspire;
            attrs.vehicleDetails = attrs.listingData.vehicleDetails;
            attrs.seller = responses[0].data.sellerDto;

            attrs.dealerChatAls = JSON.stringify({
                leadTypeId: attrs.listingData.isNewCarStockType ? NEW_STOCK_TYPE_CODE : USED_STOCK_TYPE_CODE,
                name: attrs.listingData.isNewCarStockType ? "New Car Chat Lead" : "Used Car Chat Lead",
                pageFromId: PAGEID
            });

            isDealerOnline(attrs.customerId).then((isOnline) => {
                attrs.isOnline = isOnline;

                if (attrs.isDealerInspire) {
                    attrs.showChat = true;
                } else if (!attrs.isActiveEngage) {
                    attrs.showChat = attrs.listingData.sellerHasDealerChatEnabled && isOnline;
                } else {
                    attrs.showChat = true;
                }

            });
         }


        function isDealerOnline(customerId) {
            return dealerChatService.isDealerOnline(customerId);
        }

        scope.callTracking = callTracking;

        function callTracking() {
            callDtmTracking();
            callAlsTracking();
        }

        function callAlsTracking() {

            const alsWebToId = (stockType) => {
                if (stockType === "Used" || stockType === "CPO") {
                    return 2412;
                } else if (stockType === "New") {
                    return 2411;
                }
            };

            const alsImpression = {
                pageToId: alsWebToId(attrs.vehicleDetails.stockTypeCode)
            };
            alsImpression.publicDeviceId = CARS.digitalData.user.profileInfo.publicDeviceId;
            alsImpression.listingId = attrs.vehicleDetails.listingId;
            alsImpression.stockTypeCode = attrs.vehicleDetails.stockTypeCode;
            alsImpression.sellerId = attrs.vehicleDetails.sellerId;

            sendAlsImpression('POST', '/ajax/a773a9c189a3ff4/1.0/impression', JSON.stringify(alsImpression), "application/json").then(data => {}).catch((e) => console.log("error", e));
        }

        function sendAlsImpression(method, url, data = "", header = "") {
            return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open(method, url);
                xhr.setRequestHeader("Content-Type", header);
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    } else {
                        reject(Error(xhr.statusText));
                    }
                };
                xhr.onerror = reject;
                xhr.send(data);
            });
        }

        function callDtmTracking(contactMethod = 'call-seller', pageCategory = 'call', eventDetail = 'call') {
            let lead = {
                category: pageCategory,
                name: contactMethod,
                location: 'vdp',
                stockType: attrs.vehicleDetails.stockTypeCode,
                customerId: attrs.customerId,
                listingId: attrs.vehicleDetails.listingId,
                cpo: attrs.vehicleDetails.isCpoVehicle,
                make: attrs.vehicleDetails.makeName,
                model: attrs.vehicleDetails.modelName,
                bodyStyle: attrs.vehicleDetails.bodystyleName,
                year: attrs.vehicleDetails.modelYear,
                price: attrs.vehicleDetails.price,
                dealer: attrs.vehicleDetails.dealerName,
            };
            pageStateService.push('page.lead', lead, false);
            pageStateService.push('event', { eventDetail, eventName: 'lead' }, true);
        }

        scope.openEmbeddedChat = function() {
            leadFormService.setDefaultToChatTab(true);
        };

        scope.callProgramAlsTracking = callProgramAlsTracking;

        function callProgramAlsTracking() {
           const alsImpression = {
                pageToId: 2134
            };

            alsImpression.publicConsumerId = CARS.digitalData.user.profileInfo.publicConsumerId;
            alsImpression.publicDeviceId = CARS.digitalData.user.profileInfo.publicDeviceId;
            alsImpression.listingId = attrs.vehicleDetails.listingId;
            alsImpression.stockTypeCode = attrs.vehicleDetails.stockTypeCode;
            alsImpression.sellerId = attrs.vehicleDetails.sellerId;

            sendAlsImpression('POST', '/ajax/a773a9c189a3ff4/1.0/impression', JSON.stringify(alsImpression), "application/json").then(data => {}).catch((e) => console.log("error", e));
        }
	}
}

directive.$inject = ['sellerService', '$q', 'dealerChatService', 'pageStateService', 'leadFormService'];

export default directive;
